import React, { useEffect, useState } from "react";
import { Switch, Tooltip } from "antd";
import Organizer from "components/organizer";
import { Localize } from "components/service";
import { usePermissionByObject } from "components/permissions";
import { emailChannelUseMutation } from "../hooks";
import type { TEmailChannel } from "../helpers/email-channel-types-helper";

interface IEmailChannelStatusFieldProps {
  channel: TEmailChannel;
  variables: Record<string, any>;
}

const EmailChannelStatusField: React.FC<IEmailChannelStatusFieldProps> = ({
  channel,
  variables,
}) => {
  const [active, setActive] = useState(channel.is_active === true);
  const { hasPermission } = usePermissionByObject(Organizer.Const.permissions.UPDATE);
  const {
    _setEmailChannelCreateUpdate,
    loadingMutationEmailChannelCreateUpdate,
  } = emailChannelUseMutation.createUpdate(channel.id, variables);

  useEffect(() => setActive(channel.is_active === true), [channel.is_active]);

  const handleChange = async (checked: boolean) => {
    setActive(checked);
    try {
      await _setEmailChannelCreateUpdate({
        variables: {
          input: {
            id: channel.id,
            exhibition_type_id: channel.exhibition_type_id,
            is_active: checked,
            is_visible: channel.is_visible === true,
          },
        },
      });
    } catch (_) {
      setActive(!checked);
    }
  };

  return (
    <Tooltip
      overlayClassName="email-channel-tooltip"
      placement="bottom"
      title={
        active
          ? <Localize>EMAIL_CHANNEL.Tooltip_Deactivate</Localize>
          : <Localize>EMAIL_CHANNEL.Tooltip_Activate</Localize>
      }
    >
      <span className="email-channel-state-control">
        <Switch
          checked={active}
          disabled={!hasPermission || loadingMutationEmailChannelCreateUpdate}
          onChange={handleChange}
        />
        <span className={active ? "is-active" : "is-inactive"}>
          <Localize>
            {active
              ? "EMAIL_CHANNEL.Status_Active"
              : "EMAIL_CHANNEL.Status_Inactive"}
          </Localize>
        </span>
      </span>
    </Tooltip>
  );
};

export default EmailChannelStatusField;
